module.exports = __webpack_public_path__ + "static/media/transactionFlow3DS.01801f11.png";